import { afterMarketService } from '@/services/after-market/after-market-service';
import { projectKeys } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/vue-query';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export const useAfterMarketTableQuery = (
  projectId: MaybeRefOrGetter<string>,
) => {
  return useQuery({
    queryKey: computed(() => projectKeys.afterMarket({ projectId: toValue(projectId) })),
    queryFn: () => afterMarketService.getAll(toValue(projectId)),
  });
};
